import { createContext } from 'react';
import { createContextualCan } from '@casl/react';
import ability from './ability';
import { Actions, Subjects } from '../types';

export const AbilityContext = createContext(ability);

export const Can = createContextualCan(AbilityContext.Consumer);

export const useCan = (permission: Actions, subject: Subjects) => {
	if (!ability) {
		throw new Error('Ability context is not available');
	}

	return ability.can(permission, subject);
};
